import { adminPaths } from "@app/routing/adminPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    useAvailableFrameworkCategories,
    useFrameworkCategory,
} from "../../data";
import { useFrameworkProjectTranslations } from "./i18n";

export function useProjectBreadcrumb() {
    const { framework_group_id, framework_project_id } = useParams();
    const { t, keys } = useFrameworkProjectTranslations();

    const { frameworkCategory: { projects = [] } = {} } =
        useFrameworkCategory(framework_group_id);
    const { availableFrameworkCategories } = useAvailableFrameworkCategories();

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const currentCategory = availableFrameworkCategories?.find(
            (cat) => cat.cmsGroupId === framework_group_id,
        );

        const options = projects.map((project) => ({
            name: project.name,
            param: project.id,
        }));

        const currentProject = options.find(
            (option) => option.param === framework_project_id,
        );

        setBreadcumb(adminPaths.frameworks, t(keys.breadcrumb_frameworks));
        setBreadcumb(
            adminPaths.framework_group_id_param,
            currentCategory?.name ?? "...",
        );

        setBreadcumb(
            adminPaths.framework_project_id_param,
            currentProject?.name ?? "...",
        );
    }, [
        projects,
        framework_group_id,
        framework_project_id,
        availableFrameworkCategories,
        t,
        keys,
    ]);
}
